import { RICConnector } from "@robotical/ricjs";
import WarrantyServiceFacade from "@robotical/appv2-warranty-service-lib/dist/facade/WarrantyServiceFacade";
import Logger from "../services/logger/Logger";
import { isUserRegistered, registerUser } from "./onboarding";

const SHOW_LOGS = true;
const TAG = "AddRobotsUtils";

export async function getSerialNumberFromDevice(device: BluetoothDevice) {
    Logger.info(SHOW_LOGS, TAG, "Getting serial number from device: " + device.name);
    try {
        const ricConnector = new RICConnector();
        const isConnected = await ricConnector.connect("WebBLE", device);
        if (isConnected) {
            const ricSystem = ricConnector.getRICSystem();
            const systemInfo = await ricSystem.getRICSystemInfo(true);
            const serialNumber = systemInfo.SerialNo;
            await ricConnector.disconnect();
            return serialNumber;
        }
        disconnectRepeatedly(ricConnector, 500, 2000);
        return undefined;
    } catch (error) {
        Logger.error(SHOW_LOGS, TAG, "Error getting serial number from device: " + error);
        return undefined;
    }
}

async function disconnectRepeatedly(ricConnector: RICConnector, interval: number, timeout: number) {
    Logger.info(SHOW_LOGS, TAG, "Disconnecting repeatedly from device: " );
    const startTime = Date.now();
    const intervalId = setInterval(async () => {
        const isConnected = ricConnector.isConnected();
        if (!isConnected || Date.now() - startTime > timeout) {
            clearInterval(intervalId);
        } else {
            try {
                await ricConnector.disconnect();
            } catch (error) {
                Logger.error(SHOW_LOGS, TAG, "Error disconnecting from device: " + error);
            }
        }
    }, interval);
}

export const addRobotsToUser = async (email: string, serialNumbers: string[]) => {
    Logger.info(SHOW_LOGS, TAG, "Adding robots to user with email: " + email);
    try {
        // first check if the user exists
        const isRegistered = await isUserRegistered(email, true);
        if (!isRegistered) {
            Logger.error(SHOW_LOGS, TAG, "User is not registered: " + email, " registering user");
            const didRegister = await registerUser(email, "", serialNumbers);
            if (!didRegister) {
                Logger.error(SHOW_LOGS, TAG, "Error registering user: " + email);
                return false;
            }
            Logger.info(SHOW_LOGS, TAG, "User registered successfully: " + email);
            return true;
        }
        return await WarrantyServiceFacade.appendSerialNumbersToUser(email, serialNumbers);
    } catch (error) {
        Logger.error(SHOW_LOGS, TAG, "Error adding robots to user: " + error);
        return false;
    }
}